<template>
  <div class="book-res-container">
    <div class="book-res-header">
      <span>备课详情:{{ teaName }}老师</span>
      备课教材：
      <Select
        v-model="bookId"
        filterable
        placeholder="请选择教材"
        @on-change="changeBook"
      >
        <Option v-for="item in bookLList" :value="item.id" :key="item.id"
          >{{ item.bookName }}
        </Option>
      </Select>
    </div>
    <Layout>
      <Sider hide-trigger width="240">
        <div class="sider-tree-container">
          <el-tree
            :data="bookMenuList"
            :style="treeStyle"
            node-key="id"
            :render-content="renderContent"
            @current-change="queryResourceByMenu"
            @node-drop="handleDrop"
            :allow-drop="allowDrop"
            :allow-drag="allowDrag"
            draggable
          >
          </el-tree>
        </div>
      </Sider>
      <Content>
        <div>
          <div class="resource-list">
            <template v-if="resourceList.length > 0">
              <resource-item
                v-for="(item, index) in resourceList"
                :subItem="item"
                :index="index"
                @openPreview="openPreview"
              ></resource-item>
              <div class="clearfix"></div>
            </template>
            <div class="no-data" :style="{ paddingTop: paddingTop }" v-else>
              <img
                src="../../../../assets/images/databoard/detailPage/nodata.png"
                alt=""
                class="no_pic"
              />
              <span class="txt">暂无资源</span>
            </div>
          </div>
          <div class="bottom-page">
            <div class="laypage_main">
              <Page
                :total="pageParams.total"
                @on-change="handleCurrentChange"
                :current="pageParams.page"
                v-if="pageParams.total && pageParams.pageCount > 1"
                show-total
              ></Page>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
    <!-- 预览轮播 -->
    <dt-preview-slider
      ref="previewSlider"
      :previewMode="previewMode"
      :previewVideoMode="previewVideoMode"
      :videoSrc="videoSrc"
      @closePreview="closePreview"
    ></dt-preview-slider>
  </div>
</template>

<script>
import {
  getBookList,
  getCommonCatchList,
  getStructureCatalogList,
  getResourceList,
} from "../../../../service/api.js";
import { mapGetters } from "vuex";
import ResourceItem from "../../../../components/ResourceItem.vue";
import Resource from "../../../site/region/resource.vue";

export default {
  name: "tea-book-resource",
  computed: {
    ...mapGetters([]),
  },
  components: {
    ResourceItem,
    Resource,
  },
  props: {
    teaId: String,
    teaName: String,
  },
  data() {
    return {
      bookLList: [],
      curBookInfo: {},
      bookMenuList: [],
      bookCode: "",
      bookId: "",
      catalogCode: "",
      resourceList: [],
      treeStyle: {
        height: "",
        overflowY: "auto",
      },
      pageParams: {
        page: 1,
        limit: 24,
        total: 0,
        pageCount: 0,
      },
      paddingTop: "10%",
      previewMode: false,
      previewVideoMode: false,
      videoSrc: "",
    };
  },
  methods: {
    /**
     * @name 获取当前用户的课本
     */
    async getTeachertBookList() {
      const res = await getBookList({
        userId: this.teaId,
        token: this.$store.getters.token,
      });
      if (res) {
        this.bookLList = res;
      }
      this.calTreeStyle();
    },
    /**
     * @name 获取当前用户的默认课本
     */
    async getDefaultBook() {
      const res = await getCommonCatchList({
        appType: 113,
        uId: this.teaId,
      });
      if (res && res.catch_list) {
        this.curBookInfo = JSON.parse(res.catch_list);
        this.bookCode = this.curBookInfo.bookCode;
        this.bookId = this.curBookInfo.bookId;
        await this.getMenuList();
      }
      this.calTreeStyle();
    },
    // 获取目录列表
    /**
     * @name 获取当前课本的目录列表
     */
    async getMenuList() {
      const res = await getStructureCatalogList({
        bookCode: this.bookCode,
      });
      if (res) {
        this.bookMenuList = res;
        this.bookMenuList.unshift({
          code: "0",
          endPageCode: "",
          expan: true,
          hasSchoolRes: "",
          id: "0",
          isOpen: 1,
          pcode: "",
          pid: "0",
          quesCount: "0",
          sort: 1,
          startPageCode: "",
          title: "全部",
          children: [],
        });
      }
      await this.findResourceList();
      this.calTreeStyle();
    },
    /**
     * @name 渲染目录树
     * @param {*} h
     * @param {*} param1
     */
    renderContent: (h, { root, node, data }) => {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            cursor: "pointer",
            userSelect: "none",
          },
        },
        [
          h(
            "div",
            {
              style: {
                display: "flex",
              },
            },
            [
              h("Icon", {
                props: {
                  type: "document-text",
                },
                style: {
                  marginRight: "8px",
                },
              }),
              h(
                "p",
                {
                  style: {
                    width: "200px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  },
                },
                data.title
              ),
            ]
          ),
        ]
      );
    },
    /**
     * @name 通过点击目录查询资源
     * @param {*} val
     * @param {*} node
     */
    async queryResourceByMenu(val, node) {
      this.catalogCode = val.code;
      await this.findResourceList();
    },
    /**
     * 初始化树高度
     */
    calTreeStyle() {
      this.$nextTick(() => {
        let btnHeight = 0;
        if (this.isShowBtn) {
          btnHeight =
            document.getElementsByClassName("menu-btn-bar")[0].offsetHeight;
        }
        this.treeStyle.height = window.innerHeight - btnHeight - 265 + "px";
        // this.treeStyle.height = "100%";
      });
    },
    /**
     * @name 获取课本下资源
     */
    async findResourceList() {
      let res = await getResourceList({
        schoolId: this.$route.params.schoolId || this.$store.getters.schoolId,
        userId: this.teaId,
        appType: 2,
        bookCode: this.bookCode,
        catalogCode: this.catalogCode,
        page: this.pageParams.page,
        limit: this.pageParams.limit,
        //parentId: 0,
        isFolder: 0,
        sortType: 0,
        order: "desc",
        subCatalogRes: 1,
      });
      if (res) {
        res.rows.forEach((item) => {
          if (item.fileSize) {
            item.fileSize = this.$utils.bytesToSize(item.fileSize);
          }
          item.createTimeFormat = item.createTime.substring(
            5,
            item.createTime.length - 3
          );
        });
        this.resourceList = res.rows;
        this.pageParams.total = res.total_rows;
        this.pageParams.pageCount = res.page_count;
      }
    },
    /**
     * 改变当前选择课本
     */
    async changeBook(val) {
      const curBook = this.bookLList.filter((item) => {
        return item.id === val;
      })[0];
      if (curBook) {
        this.bookCode = curBook.bookCode;
      }
      await this.getMenuList();
    },
    /**
     * 预览资源
     */
    async openPreview(resultUrl, count, type, index) {
      if (type === 2) {
        this.previewVideoMode = true;
        this.videoSrc = resultUrl + "/video.mp4";
        return;
      } else if (type === 3) {
        this.$set(this.resourceList[index], "isPlaying", 1);
        return;
      }
      if (!count) {
        this.$Message.error("暂无缩略图，无法预览！");
        return;
      }
      this.previewMode = true;
      this.$refs.previewSlider.swiperInit(resultUrl, count);
    },
    // 关闭预览
    closePreview(type) {
      this[type] = false;
    },
    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.findResourceList();
    },
  },
  async mounted() {
    await this.getTeachertBookList();
    await this.getDefaultBook();
  },
};
</script>

<style lang="scss" scoped>
.book-res-container {
  height: 100%;
  width: 100%;
  padding: 0 20px;
  .book-res-header {
    height: 40px;
    line-height: 40px;
    background: #f2f5f3;
    text-align: left;
    padding: 0 30px;
    margin-bottom: 20px;
    display: flex;
    font-size: 12px;
    font-weight: bold;
    span {
      &:first-child {
        margin-right: 60px;
      }
    }
  }
  .resource-list {
    padding: 0 12px;
  }

  .clearfix {
    &:before,
    &:after {
      display: table;
      content: " ";
    }

    &:after {
      clear: both;
    }
  }
  .no-data {
    text-align: center;
    .no_pic {
      display: block;
      margin: auto;
      width: 352px;
      height: 203px;
    }
    .txt {
      text-align: center;
      margin: auto;
      display: inherit;
      color: #545454;
      margin-top: 40px;
      font-size: 16px;
    }
    .cj {
      cursor: pointer;
      color: rgb(6, 168, 240);
    }
  }
  .bottom-page {
    width: unset !important;
  }
}
</style>

<style lang="scss">
@import "../../../../style/resourceList";
.book-res-container {
  .ivu-layout {
    height: calc(100% - 60px);
    background: #fff !important;
  }
  .ivu-layout-sider,
  .ivu-layout-content {
    height: 100%;
    background: #fff;
    // overflow: auto;
  }
}
.book-res-header {
  .ivu-select {
    width: 200px !important;
    margin-top: 4px;
  }
}
.book-res-container {
  .sider-tree-container {
    text-align: left;
    .el-tree {
      // padding : 10px 20px 20px;
    }
    .el-tree-node__content {
      height: 34px !important;
      text-align: left !important;
    }
  }
}
</style>

